import React, { useMemo } from 'react'
import { CommonLink } from '@frontend/pole-ui/lib/components/CommonLink'
import { InjectHtml } from '@/components/ui'
import { ELegalDocumentsRoute } from '@/types/ELegalDocumentsRoute'
import { formatLocalizedString } from '@/utils/formatUtils'
import { createRouterLink } from '@/utils/url'
import type { IDocumentContent } from '../../../pages/LegalDocumentsPage/interfaces'
import { messages } from '../../../pages/LegalDocumentsPage/messages'
import { sortPreviousDocumentVersionsByAscendingCreationDate } from './helpers'
import './styles.scss'

const DocumentContent: React.FC<IDocumentContent> = props => {
  const { documentId, content, previousVersions = [], isActualDocumentVersion, annexes = [] } = props

  const sortedPreviousVersions = useMemo(() => {
    const previousVersionsToShow = isActualDocumentVersion ? previousVersions : []
    const sortedVersions = sortPreviousDocumentVersionsByAscendingCreationDate(previousVersionsToShow ?? [])

    return sortedVersions
  }, [isActualDocumentVersion, previousVersions])

  return (
    <div className="documentComponent">
      <div className="documentComponent__article">
        <InjectHtml html={content} />
        <div className="documentComponent__annexes">
          {annexes.map((annexe, index) => (
            <div className="documentComponent__annexesParagraph" key={annexe.url || index}>
              <CommonLink className="color_green underline underline_green" url={annexe.url} isDocument={annexe.isDocument}>
                {formatLocalizedString(messages.annexes.text, { numberAnnexes: annexe.index })}
              </CommonLink>
            </div>
          ))}
        </div>
      </div>

      <div className="documentComponent__previous">
        {sortedPreviousVersions
          .map(({ id: versionId, version }) => (
            <p className="documentComponent__previousParagraph" key={versionId}>
              <CommonLink
                url={createRouterLink(ELegalDocumentsRoute.DOCUMENT_VERSION, {
                  documentId,
                  versionId,
                })}
                target="_blank"
                className="color_green underline underline_green"
                shouldOpenInNewWindow
              >
                {formatLocalizedString(messages.document.version, {
                  version,
                })}
              </CommonLink>
            </p>
          ))
          .reverse()}
      </div>
    </div>
  )
}

export default DocumentContent
